import { useQuery } from '@tanstack/react-query';
import { Family } from 'src/clients/hooks/useFamily';

export const useCompanyFamilies = (companyId: string) => {
  const { data, isLoading } = useQuery<Family[]>({
    queryKey: ['admin', 'companies', companyId, 'families'],
  });

  return {
    families: data ?? [],
    isLoading,
  };
};
